<template>
    <div class="reportList-wrap">

      <Modal
        class="reportList "
        width="1200"
        :closable="false"
        footer-hide
        :mask-closable="false"
        v-model="parameter">
        <div slot="header">
          <p class="header-title">历史病历
            &nbsp;
            &nbsp;
            &nbsp;
            &nbsp;
            <span>姓名:</span>
            <span>{{present.name}}</span>
            &nbsp;
            &nbsp;
            <span>年龄:</span>
            <span>{{present.age}}</span>
            &nbsp;
            &nbsp;
            <span>性别:</span>
            <span>{{present.sex}}</span>
          </p>
        </div>

         <Row>
            <Col span="24">

              <div class="report-right">
                <Table :columns="historyTable" :data="historyList"></Table>
              </div>

            </Col>
         </Row>

         <div class="record-footer">
            <Button @click="handlerCancle">关闭</Button>
        </div>
      </Modal>

    </div>
</template>

<script>
import { api } from '@/services'
import { mapGetters } from 'vuex'
export default {
  name: 'caseInfoHistory',
  props: {
    parameter: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      present: {
      },
      // 报告列表
      historyList: [],
      historyTable: [{
        title: '就诊科室',
        key: 'deptName'
      }, {
        title: '就诊医生',
        key: 'doctorName'
      },{
        title: '主诉',
        key: 'mainSuit'
      }, {
        title: '诊断',
        key: 'diagnosis'
      }, {
        title: '处置意见',
        key: 'treatIdea'
      }, {
        title: '时间',
        key: 'date',
        width:'200px'
      }]
    }
  },

  created: function () {
  },

  methods: {
    ...mapGetters({
      headerUserRest: 'prvateConsultation/headerUserRest'
    }),
    // 查看历史病历列表
    getReportList () {
      api.getOlCaseInfoHistory({
        data: {
          params: {
            // card_id: this.$store.state.prvateConsultation.headerUserRest.cardId,
            orderId: this.$store.state.prvateConsultation.orderId
            // person_id: 6179
          }
        }
      })
        .then(res => {
          if (res.data && res.data.list && res.data.list.length > 0) {
            this.historyList = res.data.list
            this.present = res.data.personInfo
            this.$emit('reportLengthFunc', res.data.list.length)
          }
        })
    },
    handlerCancle () {
      this.$emit('handlermodalCancel', {
        parameter: false
      })
    }

  },
  computed: {
    orderId () {
      return this.$store.state.prvateConsultation.orderId
    }
  },
  watch: {
    orderId: function (val) {
      // console.log(val)
      if (val) {
        this.getReportList()
      }
    }
  }
}

</script>

<style>
.header-title{
  background: #72beff;
  color: #fff;
}
.reportList{
  min-height: 600px;
}
.ivu-modal{
  width: 80% !important;
}
.reportList .ivu-modal-header{
  background: #72beff;
  color: #fff;
}
.reportList .ivu-modal-body{
  padding: 0.5 !important;
}
.reportList .ivu-modal-header p{
  color: #fff !important;
}
.report-list-ul{
  height: 10rem;
  overflow: auto;
  border: 1px solid #e3e3e3;
  /* border-bottom: none; */

}
.report-list-li{
  border-bottom: 1px solid #e3e3e3;
  padding: 0.2rem;
  cursor: pointer;
  font-size: 0.33rem;
}
.report-list-li:last-child(){
  border-bottom: none;
}
.report-type{
  color: #fff;
  font-size: 0.33rem;
  background: #32C5FF;
  padding: 0.08rem 0.15rem;
  border-radius: 1rem;
}
.flag1{
  background: #F7B500;
}
.report-title{
  font-size: 0.375rem;
  text-align: center;
  margin-left: 0.7rem;
}
.report-title-p{
   margin-bottom: 0.3rem;
}

/* 检查报告 */
.report-right{
  padding: 0 0.5rem;
}
.check-data{

}
.report-name-present{
  font-size: 0.45rem;
  color: #333333;
  margin-bottom: 0.5rem;
}

.title-report-code{
  display: inline-block;
  vertical-align: top;
  font-size: 0.33rem;
  color: #8A8A8A;
}
.des-report-code{
  display: inline-block;
  vertical-align: top;
  font-size: 0.33rem;
  margin-left: 0.3rem;
  line-height: 0.6rem;
  color: #333333;
  width: 78%;
}
.ecg-item-list{
  display: block;

}

.report-right{
  position: relative;
  height: 10rem;
  overflow: auto;
}
.reportList .seek-img-list{
  /* position: absolute; */
  bottom: 0.5rem;
  width: 55%;
  overflow: auto;
  margin: 0 auto;
}
</style>



// WEBPACK FOOTER //
// src/components/private_consultation_page/fun_right/caseInfoHistory/index.vue